import React, { useState, useEffect, useContext, useRef } from 'react';

import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import QuotationService from "../../Controller/QuotationController";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import CustomerService from "../../../Customer/Controller/CustomerController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import { handleChange, handleSubmit } from "../../../Jobs/Controller/CreateJobController";
import IssuePriorityService from "../../../Setup/controller/IssuePriorityController/IssuePriorityController";
import IssueStatusService from "../../../Setup/controller/IssueStatusController/IssueStatusController";
import ProjectCategoryService from "../../../Setup/controller/ProjectCategoryController/ProjectCategoryController";
import ProjectService from "../../../Setup/controller/ProjectMemberController/ProjectMemberController";
import { handleChange as handlePartChange, handleSubmit as handlePartSubmit } from "../../../Jobs/Controller/CreateJobPartController";
import { handleChange as handleSaleChange, handleSubmit as handleSaleSubmit } from "../../../SaleOrder/Controller/CreateSaleOrderController";
import JobService from "../../../Jobs/Controller/JobController";
import PartService from "../../../Parts/Controller/PartController";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
const useServiceJob = (setLoading, setSelectedParts, tableRef, fetchQuotation) => {

  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
    return { date, time };
  };
  const { date, time } = getCurrentDateTime();

  const [errors, setErrors] = useState({});
  const activeDateFormat = useDateFormat();
  const [ProjectCategoryList, setProjectCategory] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const fetchProject = async () => {
    try {

      const redirectCallback = () => navigate('/');
      const list = await ProjectService.GetProjectMemberByID(redirectCallback);
      const DefaultProjectList = list[0].filter(project => project.IsDefault == 1);
      if (DefaultProjectList.length > 0) {
        return DefaultProjectList[0].ID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };
  const fetchProjectCategory = async (ProjectID) => {
    try {
      setProjectCategory([]);
      const redirectCallback = () => navigate('/');
      const list = await ProjectCategoryService.GetAllProjectCategories(redirectCallback, ProjectID);
      const defaultCategory = list.find(priority => priority.IsDefault === 1);
      if (defaultCategory) {
        return defaultCategory.ProjectCategoriesID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching customer contacts:', error);
    }
  };
  const fetchIssuePriority = async () => {
    try {

      const redirectCallback = () => navigate('/');
      const list = await IssuePriorityService.GetAllIssuePriority(redirectCallback);
      const defaultPriority = list.find(priority => priority.IsDefault === 1);
      if (defaultPriority) {
        return defaultPriority.ID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching issue priorities:', error);
    }
  };
  const fetchIssueStatus = async () => {
    try {

      const redirectCallback = () => navigate('/');
      const list = await IssueStatusService.GetAllIssueStatus(redirectCallback);
      const defaultStatus = list.find(status => status.IsDefault === 1);
      if (defaultStatus) {
        return defaultStatus.ID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching issue statuses:', error);
    }
  };
  const fetchQuotationDetail = async (QuotationID) => {
    try {
      const redirectCallback = () => navigate('/');
      const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, QuotationID, "1");
      return quotationDetail;
    } catch (error) {
      console.error('Error fetching agreement details:', error);
    }
  };
  const fetchStockLocations = async (PartID) => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
      return listOfLocations;
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const fetchQuotationItems = async (QuotationID, currencySymbol, ConversionRate) => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const quotationDetails = await QuotationService.GetQuotationItem(redirectCallback, QuotationID);

      const selectedPartsData = await Promise.all(quotationDetails.map(async (detail) => {

        const listOfLocations = await fetchStockLocations(detail.FK_Stock_ID);

        let LocationID = 0;
        let DepotName = "";
        let DepotQuantity = "";
        if (listOfLocations.length === 1) {
          LocationID = listOfLocations[0].PK_StockLocation_ID;
          DepotName = listOfLocations[0].DepotName;
          DepotQuantity = listOfLocations[0].dec_Quantity - listOfLocations[0].dec_Allocated;
        }
        const convertedStockPrice = parseFloat(detail.mon_StockPrice * ConversionRate).toFixed(2);
        const convertedmon_SalesPrice = parseFloat(detail.mon_SalesPrice * ConversionRate).toFixed(2);
        const converteddec_VAT = parseFloat(detail.dec_VAT * ConversionRate).toFixed(2);
        const converteddec_Quantity = parseFloat(detail.dec_Quantity * ConversionRate).toFixed(2);
        const convertednet_SalesPrice = parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2);
        const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
        const convertedmon_SellingPrice = parseFloat(detail.mon_SellingPrice * ConversionRate).toFixed(2);
        const convertedmon_dec_Allocated = parseFloat(detail.dec_Allocated * ConversionRate).toFixed(2);
        const convertedmon_dec_FreeStock = parseFloat(detail.dec_FreeStock * ConversionRate).toFixed(2);
        const convertedmon_mon_AverageCostPrice = parseFloat(detail.mon_AverageCostPrice * ConversionRate).toFixed(2);

        return {
          vc_StockCode: detail.vc_StockCode,
          vc_Description: detail.vc_Description,
          mon_StockPrice: convertedStockPrice, // Use the converted price
          mon_SalesPrice: convertedmon_SalesPrice,
          dec_Quantity: detail.dec_Quantity,
          vc_UnitOfSale: detail.vc_UnitOfSale,
          net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
          net_VATPrice: parseFloat(converteddec_VAT).toFixed(2),
          vc_StockName: detail.vc_Description,
          PK_Stock_ID: detail.FK_Stock_ID,
          dec_Discount: detail.dec_Discount,
          mon_SellingPrice: convertedmon_SalesPrice,
          dec_Allocated: convertedmon_dec_Allocated,
          dec_FreeStock: convertedmon_dec_FreeStock,
          mon_AverageCostPrice: convertedmon_mon_AverageCostPrice,
          mon_NetPrice: parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2),
          mon_VATPrice: parseFloat(detail.net_VATPrice * ConversionRate).toFixed(2),
          mon_DiscountNetPrice: parseFloat(detail.dec_Discount * ConversionRate).toFixed(2),
          LocationID: LocationID,
          DepotName: DepotName,
          DepotQuantity: DepotQuantity
          // Map other fields as needed
        };
      }));

      return selectedPartsData;

    } catch (error) {
      console.error('Error fetching supplier details:', error);
    }
  };


  const handleServiceJob = async (event, selectedId) => {
    setLoading(true);
    try {

      const redirectCallback = () => navigate('/');
      const quotationDetail = await fetchQuotationDetail(selectedId);
      const listOfCustomers = await CustomerService.GetAllCustomersForQuotation(redirectCallback);
      const selectedCustomer = listOfCustomers.find(customer => customer.ClientCompanyID === parseInt(quotationDetail[0].CustomerID));
      const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
      const listOfCurrency = await CurrencyService.DefaultCurrency(redirectCallback);
      const ConversionRate = await convertCurrency(listOfCurrency[0].Symbol, selectedCustomer.vc_CurrencySymbol, currencyData, "0");

      const QuotationItemsList = await fetchQuotationItems(selectedId, selectedCustomer.vc_CurrencySymbol, "1");
      const s1QuotationItems = QuotationItemsList.filter(item => item.vc_StockCode === "S1");

      if (s1QuotationItems.length > 0) {
        const concatenatedDescriptions = s1QuotationItems.map(item => item.vc_StockName).join(', ');
        const formData = {
          CustomerID: quotationDetail[0].CustomerID,
          FK_ClientBranch_ID: quotationDetail[0].FK_ClientBranch_ID,
          FK_ClientContact_ID: quotationDetail[0].FK_ClientContact_ID,
          IssueTitle: concatenatedDescriptions,
          Estimate: quotationDetail[0].mon_TotalPriceG,

          mon_JobCost: "0.00",
          BaseCurrency: listOfCurrency[0].Symbol,
          EstimatedCurrency: selectedCustomer.vc_CurrencySymbol || listOfCurrency[0].Symbol,
          CostCurrency: selectedCustomer.vc_CurrencySymbol || listOfCurrency[0].Symbol,
        };

        // Additional formData properties
        formData.EstimateBaseToCurrencyRate = ConversionRate;
        formData.CostBaseToCurrencyRate = ConversionRate;
        formData.Invoiced = "0";
        formData.ID = "0";
        formData.FK_Supplier_ID = 0;
        formData.ProjectID = await fetchProject();
        formData.ProjectCategoriesID = await fetchProjectCategory(formData.ProjectID);
        formData.CallTypeID = 1;
        formData.AlertDays = "1";
        formData.AlertTime = "0";
        formData.UserID = "0";
        formData.IssuePriorityID = await fetchIssuePriority();
        formData.IssueStatusID = await fetchIssueStatus();
        formData.TimeToCall = formatDate(quotationDetail[0].dt_QuotationDate);
        formData.CallTime = "00:00:00";

        // Create the formDataWithParts object
        const formDataWithParts = {
          formData: formData,
          tableData: [] // Empty list as required
        };
        const message = await handleSubmit(event, formDataWithParts, "", setErrors);

        // part.LocationID = depot.PK_StockLocation_ID;
        // part.DepotName = depot.vc_Name;
        // part.DepotQuantity   = (depot.dec_Quantity-depot.dec_Allocated);
        // Process the remaining items
        const QuotationItems = QuotationItemsList.filter(quote => quote.vc_StockCode !== "S1");
        const newParts = QuotationItems.map(item => ({
          vc_StockCode: item.vc_StockCode,
          vc_Description: item.vc_Description,
          mon_SalesPrice: item.mon_SalesPrice,
          vc_Quantity: item.vc_Quantity,
          mon_StockPrice: item.mon_StockPrice,
          mon_AverageCostPrice: "0.00",
          vc_StockName: item.vc_StockName,
          mon_LastPurchasePrice: item.mon_LastPurchasePrice,
          dt_LastSaleDate: item.dt_LastSaleDate,
          dt_StockTakeDate: item.dt_StockTakeDate,
          dec_TaxCode: item.dec_TaxCode,
          vc_UnitOfSale: item.vc_UnitOfSale,
          snt_PurchaseNominalCode: item.snt_PurchaseNominalCode,
          snt_SalesNominalCode: item.snt_SalesNominalCode,
          dec_Quantity: item.dec_Quantity,
          PK_Stock_ID: item.PK_Stock_ID,
          dec_Allocated: "0.00",
          dec_FreeStock: "0.00",
          LocationID: item.LocationID,
          DepotName: item.DepotName,
          DepotQuantity: item.DepotQuantity,
        }));

        await setSelectedParts(prevParts => [...prevParts, ...newParts]);
        const JobID = localStorage.getItem("JobID");
        const partData = {
          ID: 0,
          FK_Issue_ID: JobID
        };
        const formDataWithQuotationItems = {
          formData: partData,
          selectedParts: newParts,
        };
        const Message = await handlePartSubmit(event, formDataWithQuotationItems, "", setErrors);
        await QuotationService.SetJobNo(selectedId, JobID);

        const NewItems = QuotationItemsList.filter(quote => quote.vc_StockCode === "S1");
        const S1Parts = NewItems.map(item => ({
          JobID: JobID,
          vc_StockCode: item.vc_StockCode,
          vc_StockName: item.vc_StockName,
          mon_SalesPrice: item.mon_SalesPrice,
        }));

        await JobService.AddIssueCost(redirectCallback, S1Parts);
        return "Data Saved";
      }
      else {
        Swal.fire(
          'Error!',
          'Please create at least one record with the S1.',
          'warning'
        );
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  return { handleServiceJob };
};

export default useServiceJob;